import { html } from '@resn/gozer-core';
import { bindAll } from 'underscore';

import { COLORS } from 'core/constants';
import getStore from 'core/store';
import { getRoute } from 'utils/get-pages';
import { lerp } from '@resn/gozer-math';

import BtnMain from 'component/btn-main';
import TextContentAnimation from 'component/text-content-animation';

const store = getStore();

import './index.scss';
import { navigate } from 'utils/router-utils';

const template = ({ options }) => html`
    <section class="section  simpleContent ${options.className} ${
    options.inverseColors ? 'inverseColors' : ''
}" align="${options.align}" ?padding-top=${options.paddingTop} ?padding-bottom=${options.paddingBottom}>
        <div data-ui="inner" class="simpleContent__inner  grid  maxWidth">
            <div data-ui="imgWrap" class="simpleContent__imageWrap" ?placeholder="${
                !options.imgId && !options.customImage
            }">
            </div>
            <div data-ui="content" class="simpleContent__content">
                <h2 data-ui="pretitle" class="simpleContent__subtitle  text-heading9">${options.subtitle}</h1>
                <h1 data-ui="title" class="simpleContent__title  text-heading3">${options.title}</h1>
                ${
                    options.body
                        ? html`<p data-ui="body" class="simpleContent__body  text-body2">${options.body}</p>`
                        : ''
                }
            </div>
        </div>
    </section>
`;

export default {
    props: {},

    options: {
        template,
        className: '',
        align: 'left',
        bgColor: COLORS.BLUE,
        highlightColor: COLORS.LIGHT_BLUE,

        paddingTop: true,
        paddingBottom: true,

        overrideAnimation: false,
        inverseColors: false,

        subtitle: 'Subtitle',
        title: 'Simple Content Title',
        body:
            'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua',
        imgSrc: null,
        assetId: null,
        customImage: null,

        btnData: {},
        // link: {
        //     name: 'link',
        //     page: 'xp1'
        // },
        // imgSrc: `${env.CDN}static/images/placeholder/image-carousel.png`,
    },

    preloadComplete(assets) {
        const { imgId } = this.options;

        if (this.customImage) this.customImage.preloadComplete(assets);

        if (imgId) {
            const img = assets[imgId].cloneNode();
            img.classList.add('simpleContent__image');
            this.ui.imgWrap.appendChild(img);
        }
    },

    async onSetup() {
        bindAll(this, 'onBtnClick');

        const { bgColor, highlightColor, link, btnData, customImage } = this.options;

        if (bgColor) this.el.style.backgroundColor = bgColor;
        if (highlightColor) this.el.style.setProperty('--highlight-color', highlightColor);

        if (link) {
            this.btn = await new BtnMain().setup({
                options: {
                    appendTo: this.ui.content,
                    onClick: this.onBtnClick,
                    ...btnData,
                },
                props: {
                    ...btnData,
                    text: link.name,
                },
            });
        }

        this.animatedContent = await new TextContentAnimation().setup({
            options: {
                el: this.ui.content,
                btn: this.btn,
            },
            props: {
                active: () => this.props.active,
            },
        });

        if (customImage) {
            this.customImage = await new customImage.class().setup({
                options: {
                    appendTo: this.ui.imgWrap,
                    ...customImage.options,
                },
            });
        }
    },

    update() {
        const { mobile, scale } = store.state;
        const { scrollProgress } = this.props;
        const { overrideAnimation } = this.options;

        if (overrideAnimation) return;

        // const yTextDist = (mobile ? 0 : 0) * scale;
        // const yText = lerp(scrollProgress, -yTextDist, yTextDist);
        const yImgDist = (mobile ? 80 : 0) * scale;
        const yImg = lerp(scrollProgress, -yImgDist, yImgDist);

        // this.ui.imgWrap.style.transform = `translateY(${yImg}px)`;
        // this.ui.content.style.transform = `translateY(${yText}px)`;
    },

    onBtnClick() {
        console.log('[simple-content-base-mixin] onBtnClick');

        const { page } = this.options.link;

        if (page === 'configure') {
            // different handle for XP1 & configure.
            navigate('/configure/xp1');
        } else {
            navigate(getRoute(page));
        }
    },
};
